import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import PasswordFormStore, { PasswordFormData } from "./PassowordFormStore";
import { useParams } from "react-router-dom";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import SubmitButton from "../../form/SubmitButton";

const UpdatePasswordStorePage: React.FC = () => {
  const { t } = useTranslation();
  const { storeId} = useParams<{ storeId: string}>();
        const numericStoreId = storeId ? parseInt(storeId):0;
  const { register, handleSubmit, formState: { errors, isSubmitting }, watch, } = useForm<PasswordFormData>({
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    }
  });

    const {loading,updateResource} = useUpdateResource();
  
      const onSubmit = (data: PasswordFormData) => {
            const url =numericStoreId?`store/update-password?storeId=${numericStoreId}`:"store";
            updateResource(url, {oldPassword:data.oldPassword,newPassword:data.newPassword} ,numericStoreId? "admin":"store",{
              method: "PUT",
              successMessage: t("update_success"),
              invalidateQueries:["store-detail-action"],
            });
          };

  return (
        <form className="flex flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
          <PasswordFormStore
            register={register}
            errors={errors}
            watch={watch}
            onSubmit={handleSubmit(onSubmit)}
            isSubmitting={isSubmitting}
          />
            {
              loading?
              <LoadingButton/>
              :
              <SubmitButton label='update'/>
            }
    </form>
  );
};

export default UpdatePasswordStorePage;
